/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Lifecycle states for users.
'active' and 'inactive' apply to all users; 'stale' and 'finished'
primarily make sense for students.
 */
export type UserLifecycleState = (typeof UserLifecycleState)[keyof typeof UserLifecycleState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserLifecycleState = {
  active: 'active',
  stale: 'stale',
  finished: 'finished',
  inactive: 'inactive',
} as const;
